

// Get all environment variables directly
const env = import.meta.env;

// Create the configuration object with defaults
export const config = {

  API_URL: env.VITE_API_URL  || 'https://app.adenin.com', // || 'https://localhost:44367'  

  // Vite's built-in MODE variable
  MODE: env.MODE || 'development',

  POSTHOG_KEY: 'phc_1mEwwsp16wREnGrf1UU67YmhTOmLioNpEyaYKQzRnUi',
  POSTHOG_HOST: 'https://eu.i.posthog.com',
};


export const isProduction = () => config.MODE === 'production';


export default config;